import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const TikTokIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TikTok</title>
      <path
        d="M34 17.1227C31.2476 17.1293 28.5627 16.2709 26.3247 14.669V25.8418C26.3239 27.9111 25.6914 29.9309 24.5117 31.6311C23.332 33.3312 21.6613 34.6307 19.7231 35.3558C17.7849 36.0808 15.6715 36.1969 13.6655 35.6885C11.6595 35.1801 9.85661 34.0714 8.49777 32.5107C7.13894 30.95 6.28899 29.0116 6.06156 26.9548C5.83414 24.898 6.24009 22.8208 7.22513 21.001C8.21016 19.1811 9.72734 17.7053 11.5738 16.771C13.4202 15.8366 15.5079 15.4882 17.5577 15.7724V21.3919C16.6197 21.0969 15.6125 21.1058 14.6799 21.4173C13.7472 21.7288 12.9369 22.3271 12.3645 23.1266C11.7922 23.9262 11.4871 24.8861 11.4929 25.8694C11.4987 26.8526 11.8151 27.8089 12.3968 28.6016C12.9785 29.3944 13.7958 29.983 14.7321 30.2836C15.6683 30.5841 16.6756 30.5811 17.6101 30.2751C18.5445 29.969 19.3584 29.3755 19.9354 28.5793C20.5124 27.7832 20.8231 26.825 20.8231 25.8418V4H26.3247C26.3208 4.46458 26.3598 4.92853 26.4409 5.38598C26.6321 6.40716 27.0296 7.37861 27.6091 8.24091C28.1886 9.10321 28.938 9.83822 29.8113 10.401C31.0538 11.2225 32.5105 11.6604 34 11.6601V17.1227Z"
        fill={fill}
      />
    </svg>
  );
};

export default TikTokIcon;
